module.exports = {
	"speed": {
		"upload": {
			"warn": 0.25,
			"error": 0.1,
			"unit": "Mbps"
		},
		"download": {
			"warn": 0.25,
			"error": 0.1,
			"unit": "Mbps"
		},
		"jitter": {
			"warn": 50,
			"error": 100,
			"unit": "ms"
		},
		"latency": {
			"warn": 50,
			"error": 100,
			"unit": "ms"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/thresholds.yaml
// module id = 126
// module chunks = 0